/* RevitaPaw shared: nav, reveal engine, cart drawer, popup, offer tab,
   button motion, ingredient cards, bundle forms. */
(function(){
'use strict';
var REDUCED=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
window.RP_REDUCED=REDUCED;
var PAW_SVG='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><ellipse cx="7" cy="8" rx="2" ry="2.6"/><ellipse cx="12" cy="6.5" rx="2" ry="2.6"/><ellipse cx="17" cy="8" rx="2" ry="2.6"/><path d="M12 11c-3.2 0-6 2.6-6 5.3 0 1.9 1.5 3.2 3.3 3.2 1 0 1.8-.4 2.7-.4s1.7.4 2.7.4c1.8 0 3.3-1.3 3.3-3.2 0-2.7-2.8-5.3-6-5.3z"/></svg>';

/* ── NAV ── */
var nav=document.getElementById('rpNav');
window.addEventListener('scroll',function(){
  if(nav)nav.classList.toggle('scrolled',window.scrollY>40);
},{passive:true});

var burger=document.getElementById('navBurger'),mMenu=document.getElementById('mobileMenu');
if(burger&&mMenu){
  burger.addEventListener('click',function(){
    var open=mMenu.classList.toggle('open');
    burger.setAttribute('aria-expanded',open);
    document.body.classList.toggle('rp-menu-open',open);
    if(open)mMenu.querySelectorAll('a').forEach(function(a,i){a.style.transitionDelay=(i*40)+'ms'});
  });
  mMenu.addEventListener('click',function(e){
    if(e.target.tagName==='A'){mMenu.classList.remove('open');document.body.classList.remove('rp-menu-open')}
  });
}

/* ── REVEAL ENGINE (retuned 2026-07-29 motion pass) ── */
/* SAFE BY DEFAULT: elements are visible in CSS. We only arm (.pre) elements
   below the viewport, when IO is available and motion allowed. Stagger 50ms,
   capped at 6 steps (later siblings reveal together). FAILSAFE is per-element:
   a second zero-margin observer force-reveals anything still armed ~1s after
   ANY pixel of it enters the viewport — a reveal can never leave on-screen
   content hidden (supersedes the old blanket 4s-after-load timer, which also
   killed scroll reveals for late scrollers). */
var revealEls=document.querySelectorAll('.reveal,.reveal-pop');
if(!REDUCED&&'IntersectionObserver' in window&&revealEls.length){
  var vh=window.innerHeight;
  var armed=[];
  revealEls.forEach(function(el){
    if(el.getBoundingClientRect().top>vh*.9){el.classList.add('pre');armed.push(el)}
  });
  armed.forEach(function(el){
    var sibs=Array.prototype.filter.call(el.parentElement.children,function(c){return c.classList.contains('pre')});
    var i=sibs.indexOf(el);
    if(i>0)el.style.transitionDelay=(Math.min(i,6)*50)+'ms';
  });
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      e.target.classList.add('vis');
      io.unobserve(e.target);
    });
  },{rootMargin:'0px 0px -10% 0px',threshold:0});
  var guard=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      guard.unobserve(e.target);
      setTimeout(function(){e.target.classList.add('vis')},1000);
    });
  },{threshold:0});
  armed.forEach(function(el){io.observe(el);guard.observe(el)});
}

/* ── image fade-in on load (motion pass 2026-07-29): only images NOT yet
   decoded get armed, so cached/instant images never blink; load/error/2.5s
   timer all resolve to visible — an image can never stay transparent ── */
if(!REDUCED){
  document.querySelectorAll('img').forEach(function(img){
    if(img.complete)return;
    img.classList.add('rp-fade');
    var done=function(){img.classList.add('loaded')};
    img.addEventListener('load',done,{once:true});
    img.addEventListener('error',done,{once:true});
    setTimeout(done,2500);
  });
}

/* ── ADJ-04 button motion: shine only in-viewport; navy click wipe (non-blocking) ── */
var ctaBtns=document.querySelectorAll('.btn-buy,.btn-sun');
if(!REDUCED&&'IntersectionObserver' in window&&ctaBtns.length){
  var bio=new IntersectionObserver(function(entries){
    entries.forEach(function(e){e.target.classList.toggle('btn-shine',e.isIntersecting)});
  },{threshold:.5});
  ctaBtns.forEach(function(b){bio.observe(b)});
}
/* (ADJ-04 navy click-wipe JS DELETED 2026-07-29 — buttons now press into
   their offset shadow via CSS :active; no colour swap on click) */

/* (dose-bar fill + expand-in-place removed 2026-07-27 — the calm-stack grid
   is now static "variation2" cards; doses shown as mg pills, no interaction) */

/* (BR-21 two-row review carousel JS removed 2026-07-28 — the reviews sections
   are now a native-scroll photo strip + settings-driven card grid, no JS.) */

/* ── BR-18 comparison ticks pop in (shared: home + PDP; visible by default) ── */
(function(){
  var R=window.RP_REDUCED||window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tbl=document.querySelector('.cmp-table');
  if(!tbl||R||!('IntersectionObserver' in window))return;
  if(tbl.getBoundingClientRect().top<=window.innerHeight)return;
  tbl.classList.add('tick-pre');
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      tbl.classList.add('tick-go');
      io.disconnect();
    });
  },{threshold:.4});
  io.observe(tbl);
  window.addEventListener('load',function(){setTimeout(function(){tbl.classList.add('tick-go')},4000)});
})();

/* ── footer nav accordions (mobile only; desktop shows all links) ── */
window.footAcc=function(btn){
  if(window.matchMedia('(min-width:901px)').matches)return;
  var col=btn.closest('.foot-col');
  if(!col)return;
  var open=col.classList.toggle('open');
  btn.setAttribute('aria-expanded',String(open));
};

/* ══ CART DRAWER ══ */
var drawer=document.getElementById('cartDrawer'),
    backdrop=document.getElementById('cdBackdrop'),
    cdItems=document.getElementById('cdItems'),
    cdCount=document.getElementById('cdCount'),
    cdSubtotal=document.getElementById('cdSubtotal'),
    navCartN=document.getElementById('navCartN');
/* upsell data: real variants rendered by Liquid on the drawer element */
var UPSELL=(function(){
  try{return JSON.parse(drawer.dataset.upsell||'[]')}catch(e){return []}
})();

function money(cents){return '$'+(cents/100).toFixed(2).replace(/\.00$/,'')}

function renderCart(cart){
  if(navCartN){
    navCartN.textContent=cart.item_count;
    navCartN.classList.toggle('show',cart.item_count>0);
  }
  if(!drawer)return;
  if(cdCount)cdCount.textContent=cart.item_count;
  if(cdSubtotal)cdSubtotal.textContent=money(cart.total_price);
  if(!cdItems)return;
  if(cart.item_count===0){
    cdItems.innerHTML='<div class="cd-empty"><div class="cd-paw">'+PAW_SVG+'</div><p>Nothing here yet — your dog is waiting.</p><a class="btn btn-sun" href="/products/daily-calm-chews">Shop Now</a></div>';
    return;
  }
  var html=cart.items.map(function(it,i){
    return '<div class="cd-line" data-key="'+it.key+'">'+
      '<img src="'+(it.image?it.image.replace(/(\.[a-z]+)(\?|$)/,'_160x$1$2'):'')+'" alt="">'+
      '<div><div class="cd-line-t">'+it.product_title+'</div>'+
      '<div class="cd-line-v">'+(it.selling_plan_allocation?it.selling_plan_allocation.selling_plan.name:it.variant_title||'')+'</div>'+
      '<div class="cd-qty"><button aria-label="Decrease" onclick="RPCart.change(\''+it.key+'\','+(it.quantity-1)+')">−</button><span>'+it.quantity+'</span><button aria-label="Increase" onclick="RPCart.change(\''+it.key+'\','+(it.quantity+1)+')">+</button></div></div>'+
      '<div><div class="cd-line-p">'+money(it.final_line_price)+'</div>'+
      '<button class="cd-line-rm" onclick="RPCart.change(\''+it.key+'\',0)">Remove</button></div></div>';
  }).join('');
  /* bundle-upgrade upsell: if the cart holds a smaller bundle, offer the next one up */
  if(UPSELL.length>=3){
    var line=null,idx=-1;
    cart.items.forEach(function(it){
      UPSELL.forEach(function(u,ui){if(it.variant_id===u.id&&ui<UPSELL.length-1&&ui>idx){line=it;idx=ui}});
    });
    if(line&&idx>-1){
      var next=UPSELL[idx+1];
      var save=(UPSELL[0].price*(idx+2))-next.price;
      html+='<div class="cd-upsell"><div><div class="cd-upsell-t">Upgrade to '+next.title+' — save '+money(save)+'</div>'+
        '<div class="cd-upsell-s">'+money(Math.round(next.price/((idx+2)*100)))+'/chew · free dental sticks</div></div>'+
        '<button class="btn btn-navy" onclick="RPCart.upgrade(\''+line.key+'\','+next.id+')">Upgrade</button></div>';
    }
  }
  cdItems.innerHTML=html;
}

function fetchCart(){return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){renderCart(c);return c})}

function openDrawer(){
  if(!drawer)return;
  fetchCart();
  drawer.classList.add('open');
  if(backdrop)backdrop.classList.add('open');
  document.documentElement.style.overflow='hidden';
  document.body.classList.add('rp-drawer-open');
}
function closeDrawer(){
  if(!drawer)return;
  drawer.classList.remove('open');
  if(backdrop)backdrop.classList.remove('open');
  document.documentElement.style.overflow='';
  document.body.classList.remove('rp-drawer-open');
}
window.RPCart={
  open:openDrawer,
  close:closeDrawer,
  refresh:fetchCart,
  upgrade:function(key,variantId){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
      .then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})})})
      .then(fetchCart);
  },
  change:function(key,qty){
    var row=cdItems&&cdItems.querySelector('[data-key="'+key+'"]');
    if(qty===0&&row)row.classList.add('out');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json()}).then(renderCart);
  }
};
if(backdrop)backdrop.addEventListener('click',closeDrawer);
document.addEventListener('keydown',function(e){
  if(e.key!=='Escape')return;
  closeDrawer();
  popClose();
  if(mMenu){mMenu.classList.remove('open');document.body.classList.remove('rp-menu-open')}
});
document.querySelectorAll('[data-cart-open]').forEach(function(el){
  el.addEventListener('click',function(e){e.preventDefault();openDrawer()});
});
fetchCart(); /* badge on load */

/* ── ADJ-09 bundle forms: real /cart/add forms (work with JS off);
   JS enhances — adds exactly that variant then opens the drawer. ── */
document.querySelectorAll('form[data-bundle-form]').forEach(function(form){
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var id=Number((form.querySelector('[name="id"]')||{}).value);
    if(!id){form.submit();return}
    var btn=form.querySelector('button[type="submit"]');
    if(btn)btn.disabled=true;
    window.RP_LAST_ATC=Date.now();
    /* carry an ENABLED selling_plan input (subscribe) — charged==displayed */
    var item={id:id,quantity:1};
    var spEl=form.querySelector('input[name="selling_plan"]');
    if(spEl&&!spEl.disabled&&spEl.value)item.selling_plan=Number(spEl.value);
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})})
      .then(function(r){
        if(!r.ok)throw new Error('add failed');
        openDrawer();
        if(btn)setTimeout(function(){btn.disabled=false},600);
      })
      .catch(function(){if(btn)btn.disabled=false;form.submit()});
  });
});

/* ── Reviews links: defensive fallback — if /pages/reviews is unavailable,
   scroll to the on-page reviews section instead of dead-ending ── */
document.querySelectorAll('a[href="/pages/reviews"]').forEach(function(a){
  a.addEventListener('click',function(e){
    var anchor=document.getElementById('reviews');
    if(!anchor)return; /* no on-page fallback — navigate normally */
    e.preventDefault();
    var done=false;
    var go=function(ok){if(done)return;done=true;ok?location.href=a.href:anchor.scrollIntoView({behavior:'smooth'})};
    setTimeout(function(){go(false)},900);
    fetch(a.href,{method:'HEAD'}).then(function(r){go(r.ok)}).catch(function(){go(false)});
  });
});

/* ══ EMAIL POPUP (two-step, WELCOME10 auto-apply) ══ */
var pop=document.getElementById('rpPop'),popBackdrop=document.getElementById('popBackdrop');
var POP_KEY='rp_popup_seen';
window.RP_LAST_ATC=0;
function popEligible(){
  if(!pop)return false;
  var mm=document.getElementById('mobileMenu');
  if(mm&&mm.classList.contains('open'))return false;
  try{
    var seen=JSON.parse(localStorage.getItem(POP_KEY)||'null');
    if(seen&&Date.now()<seen.until)return false;
  }catch(e){}
  if(Date.now()-window.RP_LAST_ATC<5000)return false;
  return !pop.classList.contains('open');
}
function popOpen(force){
  if(!pop)return;
  if(!force&&!popEligible())return;
  if(force&&pop.classList.contains('open'))return;
  pop.classList.add('open');
  if(popBackdrop)popBackdrop.classList.add('open');
  pop.querySelectorAll('.pop-stick').forEach(function(s,i){
    s.style.transitionDelay=(i*80)+'ms';
    if(!REDUCED)setTimeout(function(){s.classList.add('bob')},600+i*80);
  });
  armPop=function(){};
}
function popMark(days){
  try{localStorage.setItem(POP_KEY,JSON.stringify({until:Date.now()+days*864e5}))}catch(e){}
}
function popClose(){
  if(!pop||!pop.classList.contains('open'))return;
  pop.classList.remove('open');
  if(popBackdrop)popBackdrop.classList.remove('open');
  popMark(7);
}
window.RPPop={
  open:popOpen,
  close:popClose,
  submit:function(e){
    e.preventDefault();
    var email=document.getElementById('popEmail').value;
    if(!email)return false;
    /* auto-apply WELCOME10 so checkout reconciles with the ATC sub-line */
    fetch('/discount/WELCOME10').catch(function(){});
    /* capture via Shopify customer form is posted in background */
    var form=e.target;
    if(form.action)fetch(form.action,{method:'POST',body:new FormData(form)}).catch(function(){});
    popMark(90);
    try{sessionStorage.setItem('rp_offer_redeemed','1')}catch(err){}
    if(window.RPOfferTab)RPOfferTab.hide();
    var s1=document.getElementById('popStep1'),s2=document.getElementById('popStep2');
    s1.classList.add('hide');
    s2.style.display='block';
    s2.classList.add('enter');
    requestAnimationFrame(function(){requestAnimationFrame(function(){
      s2.classList.remove('enter');
      s2.querySelectorAll('.pop-chip').forEach(function(c,i){setTimeout(function(){c.classList.add('in')},i*50)});
    })});
    return false;
  },
  segment:function(tag){
    try{localStorage.setItem('rp_segment',tag)}catch(e){}
    var done=document.getElementById('popDone');
    if(done){done.style.display='block';document.getElementById('popStep2').style.display='none'}
    setTimeout(popClose,1600);
  }
};
if(pop&&!/\/cart/.test(location.pathname)){
  var armPop=popOpen;
  setTimeout(function(){armPop()},15000);
  window.addEventListener('scroll',function onSc(){
    var doc=document.documentElement;
    if(window.scrollY/(doc.scrollHeight-doc.clientHeight)>.4){armPop();window.removeEventListener('scroll',onSc)}
  },{passive:true});
  document.addEventListener('mouseout',function(e){
    if(!e.relatedTarget&&e.clientY<=0)armPop();
  });
  if(popBackdrop)popBackdrop.addEventListener('click',popClose);
}

/* ── ADJ-08 offer tab: slides in ~600ms after paint; × -> sessionStorage
   (returns next visit); hidden on mobile while the sticky ATC bar shows ── */
(function(){
  var tab=document.getElementById('offerTab');
  if(!tab)return;
  var dismissed=false,redeemed=false;
  try{
    dismissed=sessionStorage.getItem('rp_offer_tab_dismissed')==='1';
    redeemed=sessionStorage.getItem('rp_offer_redeemed')==='1';
  }catch(e){}
  window.RPOfferTab={
    dismiss:function(){
      dismissed=true;
      tab.classList.remove('show');
      try{sessionStorage.setItem('rp_offer_tab_dismissed','1')}catch(e){}
    },
    hide:function(){redeemed=true;tab.classList.remove('show')}
  };
  if(dismissed||redeemed)return;
  /* PERSISTENT tab (2026-07-28 order — supersedes ADJ-08's sticky-bar slide-out
     AND the brief hero-CTA guard): the tab NEVER auto-hides on scroll at any
     breakpoint; it leaves only via its × (or once the offer is redeemed).
     Hero-CTA overlap is prevented by GEOMETRY instead — the mobile hero CTA
     clears the 34px tab lane (see .hero-cta-zone rules in revitapaw-home.css). */
  setTimeout(function(){tab.classList.add('show')},600);
})();

/* ── SOCIAL PROOF TOAST (kept — accepted risk) ── */
var spNotifEl=document.getElementById('spNotif');
if(spNotifEl&&!REDUCED){
  var spData=[
    {n:'Jessica M.',d:'just ordered 2 Bottles from Austin, TX',t:'2 minutes ago'},
    {n:'Rachel T.',d:'just ordered 3 Bottles from Portland, OR',t:'4 minutes ago'},
    {n:'Amanda K.',d:'just ordered 1 Bottle from Chicago, IL',t:'7 minutes ago'},
    {n:'Megan L.',d:'just reordered — her 4th purchase!',t:'9 minutes ago'},
    {n:'Olivia S.',d:'just ordered 2 Bottles from Denver, CO',t:'12 minutes ago'}
  ];
  var spIdx=0;
  var showSP=function(){
    var d=spData[spIdx%spData.length];
    document.getElementById('spN').textContent=d.n;
    document.getElementById('spD').textContent=d.d;
    document.getElementById('spT').textContent=d.t;
    spNotifEl.classList.add('show');
    setTimeout(function(){spNotifEl.classList.remove('show')},4500);
    spIdx++;
  };
  setTimeout(function(){showSP();setInterval(showSP,9000)},4000);
}
})();

/* ── POLICY PAGES (2026-07-29): Shopify renders /policies/* with its own fixed
   .shopify-policy__* markup; the pasted policy text arrives as one <div><span>
   line per row with <br> separators. Promote the section LABEL lines to bold
   subheadings (.rp-policy-sub) — deterministic rule: a leaf line that is short
   (≤60 chars), has NO terminal punctuation, and sits ALONE between <br>
   boundaries. Wrapped body lines fail the length or sibling test; sentences
   fail the punctuation test. Adjacent <br>s are absorbed so spacing is
   margin-controlled. Wording is never altered. ── */
(function(){
  var rte=document.querySelector('.shopify-policy__body .rte');
  if(!rte)return;
  var host=rte.querySelector(':scope > div')||rte;
  [].slice.call(host.querySelectorAll(':scope > div')).forEach(function(el){
    if(el.querySelector('div,p,ul,ol,h1,h2,h3,table'))return;
    var t=(el.textContent||'').replace(/\s+/g,' ').trim();
    if(!t||t.length>60)return;
    if(/[.!?:;,]$/.test(t))return;
    var p=el.previousElementSibling,n=el.nextElementSibling;
    if(p&&p.tagName!=='BR')return;
    if(!n||n.tagName!=='BR')return;
    el.classList.add('rp-policy-sub');
    if(p)p.remove();
    n.remove();
  });
})();

/* ── FAQ accordion (shared) — also mirrors state onto aria-expanded when the
   trigger button carries the attribute (Phase-2 accessibility; additive) ── */
window.toggleFaq=window.toggleFaq||function(btn){
  var item=btn.closest('.faq-item');
  var was=item.classList.contains('open');
  var scope=item.closest('.faq-list')||document;
  scope.querySelectorAll('.faq-item.open').forEach(function(i){
    i.classList.remove('open');
    var b=i.querySelector('.faq-q');
    if(b&&b.hasAttribute('aria-expanded'))b.setAttribute('aria-expanded','false');
  });
  if(!was)item.classList.add('open');
  if(btn.hasAttribute('aria-expanded'))btn.setAttribute('aria-expanded',String(!was));
};

/* ── Calm stack (shared rp-calmstack snippet, home + PDP): "See all 9
   ingredients" ⇄ "Show less" — cards 4–9 stay in the DOM, the 0fr wrapper
   animates (moved here from revitapaw-home.js 2026-07-28) ── */
window.ingMore=function(btn){
  var b=document.getElementById('ingRest');
  if(!b)return;
  var open=b.classList.toggle('open');
  btn.setAttribute('aria-expanded',String(open));
  btn.textContent=open?'Show less':'See all 9 ingredients';
};

/* ── Quick-add CTAs (CTA pass 2026-07-27): data-quickadd forms are REAL
   /cart/add POSTs (no-JS falls through to a normal submit → /cart). JS
   upgrades them: AJAX add of the fixed variant, then open the drawer. ── */
document.querySelectorAll('form[data-quickadd]').forEach(function(f){
  f.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=f.querySelector('button[type=submit]');
    var orig=btn?btn.innerHTML:'';
    var id=Number((f.querySelector('input[name="id"]')||{}).value);
    if(!id){f.submit();return}
    window.RP_LAST_ATC=Date.now();
    if(btn)btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){
        if(!r.ok)throw new Error('add failed');
        if(btn)btn.innerHTML='<span>Added to cart</span>';
        setTimeout(function(){
          if(window.RPCart)window.RPCart.open();
          if(btn){btn.innerHTML=orig;btn.disabled=false}
        },450);
      })
      .catch(function(){
        if(btn){btn.innerHTML=orig;btn.disabled=false}
        f.submit();
      });
  });
});

/* ── REVIEWS SCROLLER (Surreal-style, 2026-07-28): two rows page TOGETHER via
   one arrow pair. Movement is transform-based inside overflow:hidden rows, so
   free/independent per-row scrolling is impossible by construction; pointer
   drag is SYNCED (both tracks share one offset, snapped to a page on release).
   Lightbox: full review + the customer's own photo, closed by ✕ / overlay /
   ESC, focus-trapped. Tabbing to an off-screen card pages it into view. ── */
document.querySelectorAll('.srv').forEach(function(root){
  var rows=[].slice.call(root.querySelectorAll('.srv-row'));
  var tracks=[].slice.call(root.querySelectorAll('.srv-track'));
  var lb=root.querySelector('[data-srv-lb]'),lastF=null;
  if(tracks.length){
    var prev=root.querySelector('[data-srv-prev]'),next=root.querySelector('[data-srv-next]'),
        pageEl=root.querySelector('[data-srv-page]'),stage=root.querySelector('[data-srv-stage]');
    var off=0,rzT=null,supClick=false;
    var lead=function(){return parseFloat(getComputedStyle(tracks[0]).paddingLeft)||20};
    var step=function(){return Math.max(180,rows[0].clientWidth-2*lead())};
    var maxOff=function(){var vw=rows[0].clientWidth,m=0;tracks.forEach(function(t){m=Math.max(m,t.scrollWidth-vw)});return Math.max(0,m)};
    var apply=function(){tracks.forEach(function(t){t.style.transform='translate3d('+(-off)+'px,0,0)'})};
    var render=function(){
      var m=maxOff();off=Math.max(0,Math.min(off,m));apply();
      if(prev)prev.disabled=off<=1;
      if(next)next.disabled=off>=m-1;
      if(pageEl){var s=step(),tot=Math.max(1,Math.ceil(m/s)+1),cur=off>=m-1?tot:Math.min(tot,Math.round(off/s)+1);pageEl.textContent=cur+' / '+tot}
    };
    if(prev)prev.addEventListener('click',function(){off-=step();render()});
    if(next)next.addEventListener('click',function(){off+=step();render()});
    var moreCheck=function(){root.querySelectorAll('.srv-card').forEach(function(c){
      var q=c.querySelector('.srv-quote'),b=c.querySelector('.srv-more');
      if(q&&b)b.hidden=q.scrollHeight<=q.clientHeight+2;
    })};
    window.addEventListener('resize',function(){clearTimeout(rzT);rzT=setTimeout(function(){
      tracks.forEach(function(t){t.classList.add('noanim')});render();moreCheck();
      requestAnimationFrame(function(){tracks.forEach(function(t){t.classList.remove('noanim')})});
    },150)});
    if(stage){
      var drag=null;
      stage.addEventListener('pointerdown',function(e){
        if(e.pointerType==='mouse'&&e.button!==0)return;
        drag={x:e.clientX,o:off,id:e.pointerId,moved:false};
      });
      stage.addEventListener('pointermove',function(e){
        if(!drag)return;var dx=e.clientX-drag.x;
        if(!drag.moved){if(Math.abs(dx)<8)return;drag.moved=true;stage.classList.add('dragging');try{stage.setPointerCapture(drag.id)}catch(_){}}
        off=Math.max(0,Math.min(drag.o-dx,maxOff()));apply();
      });
      var endDrag=function(){
        if(!drag)return;var moved=drag.moved;drag=null;stage.classList.remove('dragging');
        if(moved){supClick=true;setTimeout(function(){supClick=false},80);var s=step();off=Math.round(off/s)*s;render()}
      };
      stage.addEventListener('pointerup',endDrag);
      stage.addEventListener('pointercancel',endDrag);
      stage.addEventListener('click',function(e){if(supClick){e.preventDefault();e.stopPropagation()}},true);
    }
    root.addEventListener('focusin',function(e){
      var card=e.target.closest?e.target.closest('.srv-card'):null;if(!card)return;
      var r=card.getBoundingClientRect(),rr=rows[0].getBoundingClientRect();
      if(r.left<rr.left+4||r.right>rr.right-4){off+=r.left-rr.left-lead();render()}
    });
    render();moreCheck();
    window.addEventListener('load',function(){render();moreCheck()});
  }
  /* lightbox */
  var openLb=function(card){
    if(!lb||!card)return;var d=card.dataset;
    lb.querySelector('.srv-lb-name').textContent=d.name||'Customer';
    lb.querySelector('.srv-lb-av').textContent=(d.name||'C').charAt(0).toUpperCase();
    var n=parseInt(d.rating||'5',10);
    lb.querySelectorAll('[data-lb-stars] .ic-star').forEach(function(s,i){s.classList.toggle('off',i>=n)});
    var t=lb.querySelector('.srv-lb-title');t.textContent=d.title||'';t.hidden=!d.title;
    var dt=lb.querySelector('.srv-lb-date');dt.textContent=d.date||'';dt.hidden=!d.date;
    var qn=card.querySelector('.srv-quote');
    lb.querySelector('.srv-lb-quote').textContent=qn?qn.textContent.trim():'';
    /* media: RESET FIRST on every open — src/alt/caption must never carry over
       from a previously viewed review (photoless reviews are text-only) */
    var med=lb.querySelector('.srv-lb-media'),img=med.querySelector('img'),
        cap=lb.querySelector('.srv-lb-capname'),panel=lb.querySelector('.srv-lb-panel');
    img.removeAttribute('src');img.alt='';med.hidden=true;panel.classList.add('no-media');
    if(cap)cap.textContent='Customer photo';
    if(d.img){
      img.src=d.img;img.alt=d.alt||'';med.hidden=false;panel.classList.remove('no-media');
      if(cap)cap.textContent='Customer photo — '+(d.name||'Customer');
    }
    lastF=document.activeElement;lb.hidden=false;document.body.classList.add('srv-lock');
    lb.querySelector('.srv-lb-x').focus();
  };
  var closeLb=function(){
    if(!lb||lb.hidden)return;lb.hidden=true;document.body.classList.remove('srv-lock');
    if(lastF&&lastF.focus)lastF.focus();
  };
  root.addEventListener('click',function(e){
    /* gallery-strip thumb: open the SAME lightbox for that photo's OWN review —
       resolved by block index (data-gal-open → .srv-card[data-idx]); names
       repeat across reviews, so index is the only safe key */
    var g=e.target.closest?e.target.closest('.srv-gal-thumb'):null;
    if(g){
      var c=root.querySelector('.srv-card[data-idx="'+g.getAttribute('data-gal-open')+'"]');
      if(c)openLb(c);
      return;
    }
    var t=e.target.closest?e.target.closest('.srv-more,.srv-thumb'):null;
    if(t)openLb(t.closest('.srv-card'));
  });
  /* public opener by block index (2026-07-28): lets components OUTSIDE this
     module (the PDP review teaser) open a review's own lightbox — including
     photoless reviews, which have no strip thumb to route through */
  window.rpSrvOpen=function(idx){
    var c=root.querySelector('.srv-card[data-idx="'+idx+'"]');
    if(c)openLb(c);
  };
  if(lb){
    lb.addEventListener('click',function(e){if(e.target===lb)closeLb()});
    lb.querySelector('.srv-lb-x').addEventListener('click',closeLb);
    document.addEventListener('keydown',function(e){
      if(lb.hidden)return;
      if(e.key==='Escape'){closeLb();return}
      if(e.key!=='Tab')return;
      var f=lb.querySelectorAll('button,[href],[tabindex]:not([tabindex="-1"])');
      if(!f.length)return;var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
    });
  }
});
